// extracted by mini-css-extract-plugin
export default {"addressInfo":"styles_addressInfo__YY-ey","addressItem":"styles_addressItem__Xp27E","address":"styles_address__F8vcX"};